export const LOGO = 'https://vegetablesale.jp/assets/logo-02.png';
export const SORRY =
  'https://s3-ap-northeast-1.amazonaws.com/assets.gemcook.com/images/gemo/512/gemo-ayamaru-bg-none.png';
export const MODAL_CLOSE_ICON = '/assets/icon/close.svg';

export {default as CLOSE_MODAL} from './../../assets/svg/icons/close.svg';
